import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from '@angular/core';
import { AppConfigService } from 'src/environments/app-config.service';
import {
  CreditRegisterErrorAction,
  CreditRegisterErrorViewModel,
} from '../credit-register-modal.model';

@Component({
  standalone: true,
  selector: 'app-modal-credit-register-error',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-credit-register-error.component.html',
  styleUrls: ['./modal-credit-register-error.component.scss'],
})
export class ModalCreditRegisterErrorComponent {
  @Input() open = false;
  @Input() viewModel: CreditRegisterErrorViewModel = {
    title: 'Erro!',
    description: 'Não foi possível registrar os Créditos de Carbono. Por favor, verifique as informações e tente novamente ou entre em contato com o suporte.',
  };

  @Output() action = new EventEmitter<CreditRegisterErrorAction>();

  private supportUrl = '';

  constructor(appConfig: AppConfigService) {
    this.supportUrl = appConfig.config?.urlSuporteB3 ?? 'https://atendimento.b3.com.br/atendeb3';
  }

  onModalDismiss(): void {
    this.action.emit('dismiss');
  }

  onRetry(): void {
    this.action.emit('retry');
  }

  onSupport(): void {
    if (this.supportUrl) {
      window.open(this.supportUrl, '_blank');
    }
    this.action.emit('support');
  }
}
